import { getOrCreateDeviceId } from '../offline/deviceIdentity.js';

export const POS_DEVICE_HEADER = 'x-clickorico-pos-device-id';

/** En-tête d’identification appareil POS (complété côté serveur par l’enrollment). */
export function buildPosDeviceHeaders(extra = {}) {
  try {
    const deviceId = getOrCreateDeviceId();
    return {
      [POS_DEVICE_HEADER]: deviceId,
      ...extra,
    };
  } catch {
    return { ...extra };
  }
}

export function isCaisseApiPath(endpoint) {
  return typeof endpoint === 'string' && endpoint.startsWith('/caisse');
}

export function isRdvCaisseFinancePath(endpoint, method) {
  if (method !== 'POST') return false;
  return /^\/rendez-vous\/[^/]+\/terminer$/.test(endpoint);
}

export function shouldAttachPosDeviceHeader(endpoint, method = 'GET') {
  return isCaisseApiPath(endpoint) || isRdvCaisseFinancePath(endpoint, method);
}
